<dacks-content padding="none" class="pb-6">
  @if ((productWithDelivery$ | async); as productWithDelivery) {
    <div class="flex flex-col pb-6">

      @if (isSmallScreen$ | async) {
        <div class="flex flex-col flex-1 min-h-0">
          <div class="p-6">
            @if((backButtonData$ | async); as backButton) {
              <a mat-button color="link-light" [routerLink]="backButton.link" class="mb-2" (click)="onBackButtonClick()">
                <mat-icon svgIcon="sli-pfeil-links-20"></mat-icon>
                <span>{{backButton.label}}</span>
              </a>
            }
            <!-- TODO sobald dacks-content-header auch mehrzeilig sein kann, die h1 damit umsetzen -->
            <h1 class="mu-heading-3 text-petrol-650">{{ productWithDelivery.product.title }}</h1>
          </div>
          <div class="flex-1 min-h-0 p-6 bg-white">
            <ng-container *ngTemplateOutlet="content"></ng-container>
          </div>
        </div>
      } @else {
        <div class="flex flex-col items-center flex-1 min-h-0 px-6">
          <div class="w-full mx-4 md:w-[var(--document-card-container-width)] max-w-[var(--document-card-container-width)] flex flex-col flex-1 min-h-0">
            <div class="py-6">
              @if((backButtonData$ | async); as backButton) {
                <a mat-button color="link-light" [routerLink]="backButton.link" class="mb-4" (click)="onBackButtonClick()">
                  <mat-icon svgIcon="sli-pfeil-links-20"></mat-icon>
                  <span>{{backButton.label}}</span>
                </a>
              }
              <!-- TODO sobald dacks-content-header auch mehrzeilig sein kann, die h1 damit umsetzen -->
              <h1 class="mu-heading-3 md:mu-heading-2 text-petrol-650">{{ productWithDelivery.product.title }}</h1>
            </div>
            <mat-card class="flex-1 min-h-0">
              <ng-container *ngTemplateOutlet="content"></ng-container>
            </mat-card>
          </div>
        </div>
      }
    </div>

    <ng-template #content>
      @if (!!productWithDelivery && !!productWithDelivery.product && !!productWithDelivery.deliveryDescription) {
        <div>
          <div class="flex flex-nowrap items-center justify-between mb-4 md:ml-2">
            @if (productWithDelivery.deliveryDescription.deliveryDate) {
              <div class="font-normal">
                {{productWithDelivery.deliveryDescription.deliveryDate | datePrefix }}
                {{productWithDelivery.deliveryDescription.deliveryDate | date:dateTranslation }}
              </div>
            } @else {
              <!-- Platzhalter, wenn kein Datum da ist, damit der Button rechts bleibt -->
              <div></div>
            }

            <button mat-button aria-label="Teilen per Mail" color="light" (click)="shareByMail(productWithDelivery)">
              <mat-icon svgIcon="fi-teilen-20"></mat-icon>
              <span>{{ 'common.caption_share' | translate }}</span>
            </button>
          </div>

          <mat-card class="flex flex-col sm:flex-row p-4 sm:p-6 gap-3 sm:gap-6 sm:justify-between mb-4 md:mb-6 bg-coldgray-50 box-shadow-none"
                    [ngClass]="(productWithDelivery.deliveryDescription.deliveryType === DeliveryType.ServiceRelease ||
                  productWithDelivery.deliveryDescription.deliveryType === DeliveryType.Hotfix ||
                  productWithDelivery.deliveryDescription.deliveryType === DeliveryType.ServiceReleaseAndHotfix) &&
                  productWithDelivery.product.deliveredByRdt ? 'max-w-[47.8125rem]' : 'max-w-[32rem]'">
            @if ((productWithDelivery.deliveryDescription.deliveryType === DeliveryType.ServiceRelease ||
              productWithDelivery.deliveryDescription.deliveryType === DeliveryType.Hotfix ||
              productWithDelivery.deliveryDescription.deliveryType === DeliveryType.ServiceReleaseAndHotfix) &&
            productWithDelivery.product.deliveredByRdt) {
              <div>
                <p class="font-medium">{{ 'delivery-product-details.header_precondition' | translate }}</p>
                <p class="font-normal">
                  <myupdates-delivery-bases [deliveryBases]="productWithDelivery.product.deliveryBases"></myupdates-delivery-bases>
                </p>
              </div>
            }
            <div>
              <p class="font-medium whitespace-nowrap">{{ 'delivery-product-details.header_obtainable' | translate }}</p>
              @if (productWithDelivery.deliveryDescription.deliveryType === DeliveryType.ServiceRelease ||
              productWithDelivery.deliveryDescription.deliveryType === DeliveryType.Hotfix ||
              productWithDelivery.deliveryDescription.deliveryType === DeliveryType.ServiceReleaseAndHotfix) {
                <p class="font-normal">
                  {{productWithDelivery.product.deliveredByRdt |
                  obtainable: productWithDelivery.product.deliveredByDownload | arrayToString: ', ' }}</p>
              } @else {
                <p class="font-normal">{{ 'delivery-product-details.header_main_release_obtainable' | translate }}</p>
              }
            </div>
            <div>
              <p class="font-medium">{{ 'delivery-product-details.header_trafo_required' | translate }}</p>
              <p class="font-normal">{{productWithDelivery.product.dataTransformation | yesNo}}</p>
            </div>
          </mat-card>
          <div class="max-w-[51.5rem] flex flex-col gap-4">
            @if (productWithDelivery.product.documentUrl) {
              @if ((documentBuffer$ | async); as buffer) {
                <div class="w-full overflow-hidden">
                  <doc-viewer
                    class="relative w-full aspect-[2/3] z-0 doc-viewer-responsive-workaround"
                    [src]="buffer"
                    disableDocumentHeadline="true" disableAttachments="true" disableTableOfContents="true"
                  ></doc-viewer>
                </div>
              } @else {
                @if (documentError$ | async) {
                  <myupdates-error-box class="error-box-dimmed-style"
                                       [errorTitle]="'delivery-product-details.error_title' | translate"
                                       [errorText]="'delivery-product-details.error_document_viewer' | translate">
                  </myupdates-error-box>
                } @else {
                  <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
                }
              }
            } @else {
              <myupdates-html-viewer class="document-viewer-base document-viewer-product" [documentId]="productWithDelivery.product.documentId">
              </myupdates-html-viewer>
            }
          </div>
          @if ( (contentError$ | async)) {
            <myupdates-error-box class="error-box-dimmed-style"
                                 [errorTitle]="'delivery-product-details.error_title' | translate"
                                 [errorText]="'delivery-product-details.error_document_viewer' | translate">
            </myupdates-error-box>
          }
        </div>
      } @else {
        <myupdates-error-box class="error-box-dimmed-style"
                             [errorTitle]="'delivery-product-details.error_title' | translate"
                             [errorText]="'delivery-product-details.error_product_missing' | translate">
        </myupdates-error-box>
      }
    </ng-template>


  } @else {
    <div class="p-6 bg-white">
      @if ( (errorInfo$ | async)) {
        <myupdates-error-box class="error-box-dimmed-style"
                             [errorTitle]="'delivery-product-details.error_title' | translate"
                             [errorText]="'delivery-product-details.error_rest_call' | translate">
        </myupdates-error-box>
      } @else {
        <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
      }
    </div>
  }

  <footer-spacing type="content" />
</dacks-content>
